module.exports = __webpack_public_path__ + "img/green3Dian5.f3cf11a6.png";